/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import S3 from 'react-aws-s3';
import { CamelCase, PriceHandler } from '../../../../redux/helper/CamelCase';
import { CDN } from '../../../../constants';
import UploadDocumentModal from '../Modals/UploadDocumentModal';
import { distributorService } from '../../../../service/distributor.service';
import { Invoiceconfig } from '../../../../redux/helper/upload-config';
import HeaderContext from '../../../../Components/Context/HeaderContext';

export default function Invoices({ OrderDetails, invoiceDetails, setInvoiceDetails }) {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const ReactS3Client = new S3(Invoiceconfig);
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    const [billaddresspop, setbilladdresspop] = useState(false);
    const [shipaddresspop, setshipbilladdresspop] = useState(false);
    const [hoverId, sethoverId] = useState(false);
    const [uploadDocumentModal, setUploadDocumentModal] = useState(false);
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState({});
    const [threedotsLoader, setthreedotsLoader] = useState(false);
    const [documentDetails, setDocumentDetails] = useState({});
    const [submitSelected, setsubmitSelected] = useState(false);
    const [errorIndication, setErrorIndication] = useState(false);
    const [trxNo, setTrxNo] = useState();
    const [documentNumbers, setDocumentNumbers] = useState({
        eway_bill_number: '',
        lr_number: '',

    });
    const [returnPopup, setreturnPopup] = useState('');
    const [errorState, setErrorState] = useState({
        invoice: '',
        e_way_bill: '',
        eway_bill_number: '',
        lr_copy: '',
        lr_number: '',
    });
    const InputChange = (e, key) => {
        e.preventDefault();
        const { id, value } = e.target;
        setDocumentNumbers((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleDelete = (key) => {
        const dataCopy = { ...documentDetails };
        switch (key) {
        case 'invoice':
            delete dataCopy.invoice;
            break;
        case 'lr_copy':
            delete dataCopy.lr_copy;
            break;
        case 'e_way_bill':
            delete dataCopy.e_way_bill;
            break;
        default:
            break;
        }
        setDocumentDetails(dataCopy);
    };

    const handleUploadedFiles = (val, key) => {
        const dataCopy = { ...documentDetails };
        dataCopy[key] = `${Invoiceconfig.dirName}/${val}`;
        setDocumentDetails(dataCopy);
    };

    const handleUploadDoc = (e, key) => {
        const files = e.target.files[0];
        // if (files.length === 0) {
        //     return;
        // }
        ReactS3Client.uploadFile(files, files.name)
            .then((data) => {
                handleUploadedFiles(data.key, key);
            })
            .catch((err) => err);
    };
    const validate = () => {
        let isvalid = false;
        for (let index = 0; index < Object.values(documentNumbers).length; index++) {
            if (Object.values(documentNumbers)[index] !== '') {
                isvalid = true;
                break;
            }
        }
        for (let index = 0; index < Object.values(documentDetails).length; index++) {
            if (Object.values(documentDetails)[index] !== '') {
                isvalid = true;
                break;
            }
        }
        return isvalid;
    };

    const handleUploadDocuments = async (e, orderNumber, invoiceNumber) => {
        e.preventDefault();
        if (validate()) {
            const payload = {
                invoice: documentDetails.invoice || '',
                e_way_bill: documentDetails.e_way_bill || '',
                eway_bill_number: documentNumbers.eway_bill_number || '',
                lr_copy: documentDetails.lr_copy || '',
                lr_number: documentNumbers.lr_number || '',
            };
            const res = await distributorService.UploadInvoiceDocuments(orderNumber, invoiceNumber, payload);
            if (!res?.error && res?.data?.success_status) {
                setthreedotsLoader(true);
                setUploadDocumentModal(false);
                setthreedotsLoader(false);
                SetSuccessMessage('Documents Uploaded Successfully');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            } else {
                setUploadDocumentModal(true);
                // SetErrorMessage()
            }
        }
    };
    const handlePresignedURL = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber, true);
        if (!res?.error && res?.data?.url !== null) {
            return res?.data?.url;
        }
        return false;
    };
    const handleViewInvoiceDetailsUpload = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        if (!res.error && res?.data?.success_status) {
            setViewInvoiceDetails(res?.data?.data);
            setTrxNo(res?.data?.data?.TRX_NUMBER);
            setDocumentNumbers({
                eway_bill_number: res?.data?.data?.eway_bill_number || '',
                lr_number: res?.data?.data?.eway_bill_number || '',
            });
            setDocumentDetails({
                trx_number: res?.data?.data?.TRX_NUMBER,
                e_way_bill: res?.data?.data?.e_way_bill || '',
                invoice: res?.data?.data?.invoice || '',
                lr_copy: res?.data?.data?.lr_copy || '',
            });
            setUploadDocumentModal(true);
        } else {
            SetErrorMessage(res?.message?.message);
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    return (
        <div className="tab-pane fade" id="pills-profile1" role="tabpanel" aria-labelledby="pills-profile1-tab">
            <div className="">
                <div className="flex lg:flex-row flex-col">
                    <div className="w-full">
                        <div className="w-full overflow-auto h-[500px] custom-scrollbar">
                            {invoiceDetails.length > 0 && invoiceDetails.map((invoice, idx) => (
                                <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-2.5 mb-5 pt-4 m-1 relative" key={invoice?.invoice_number}>
                                    <div className="flex flex-wrap">
                                        <div className="w-full">
                                            <div className="flex justify-between items-center mb-2">
                                                <div>
                                                    <p className="font-semibold text-xs text-[#777777]">Invoice Number</p>
                                                    <p className="font-normal text-[#090406] sm:text-xs16 text-base">{invoice?.TRX_NUMBER}</p>
                                                </div>
                                                <div className="flex items-center">
                                                    <div>
                                                        <p className="font-semibold text-xs text-[#777777]">Invoice Value</p>
                                                        <p className="text-[#090406] font-normal text-lg">{PriceHandler(invoice?.INVOICE_VALUE)}</p>
                                                    </div>
                                                    <button
                                                        onClick={() => { setUploadDocumentModal(!uploadDocumentModal); handleViewInvoiceDetailsUpload(invoice?.invoice_number); }}
                                                        type="button"
                                                        className="w-[127px] h-9 rounded-lg p-3 ml-6"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#upload-document"
                                                        style={{ backgroundColor: '#44445E' }}
                                                    >
                                                        <div className="flex items-center">
                                                            <img src="/images/download.png" alt="" />
                                                            <p className="font-semibold text-white text-xs3 ml-1.5">Upload Documents</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {uploadDocumentModal
                                        && (
                                            <UploadDocumentModal
                                                uploadDocumentModal={uploadDocumentModal}
                                                setUploadDocumentModal={setUploadDocumentModal}
                                                invoiceNumber={invoice?.TRX_NUMBER}
                                                orderNumber={invoice?.order_number}
                                                InputChange={InputChange}
                                                documentDetails={documentDetails}
                                                setDocumentDetails={setDocumentDetails}
                                                documentNumbers={documentNumbers}
                                                setDocumentNumbers={setDocumentNumbers}
                                                handleUploadDoc={handleUploadDoc}
                                                handleUploadDocuments={handleUploadDocuments}
                                                handleDelete={handleDelete}
                                                setthreedotsLoader={setthreedotsLoader}
                                                threedotsLoader={threedotsLoader}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                invoiceDetails={invoice}
                                                trxNo={trxNo}
                                            />
                                        )}
                                    <div>
                                        <div className="flex w-full lg:flex-row flex-col">
                                            <div className="flex flex-wrap items-start lg:w-[50%] w-full mb-3 mt-3">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="lg:w-[30%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">Invoice Date</p>
                                                        <p className="font-normal text-[#090406] sm:text-base text-xs">{invoice?.INVOICE_DATE}</p>
                                                    </div>
                                                    <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">E-way bill Number</p>
                                                        {invoice?.WAYBILL_NUMBER === null
                                                            ? <p className="font-normal text-[#090406] sm:text-lg text-sm">-</p>
                                                            : <p className="font-normal text-[#090406] sm:text-lg text-sm">{invoice?.WAYBILL_NUMBER}</p>}
                                                    </div>
                                                    <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">Indent Number</p>
                                                        <p className="font-normal text-[#090406] sm:text-lg text-sm">{invoice?.INDENT_NUMBER}</p>
                                                    </div>
                                                    <div className="lg:w-[30%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">Order Category</p>
                                                        <p className="font-normal text-[#090406] sm:text-lg text-sm">{invoice?.ORDER_CATEGORY}</p>
                                                    </div>
                                                    <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">Payment Status</p>
                                                        <p className="font-normal text-[#090406] sm:text-lg text-sm">{invoice?.PAYMENT_STATUS === null ? 'Pending' : invoice?.PAYMENT_STATUS}</p>
                                                    </div>
                                                    <div className="lg:w-[33%] w-[50%] pb-5 px-1">
                                                        <p className="text-xs font-semibold text-[#777777]">Order Acceptance No.</p>
                                                        <p className="font-normal text-[#090406] sm:text-lg text-sm">{invoice?.ORDER_ACCEPTANCE_NUMBER}</p>
                                                    </div>
                                                    <div className="w-auto pb-5 px-1">
                                                        {invoice?.INVOICE_LINK && invoice?.INVOICE_LINK !== null && (
                                                            <button
                                                                type="button"
                                                                onClick={async () => {
                                                                    const url = await handlePresignedURL(invoice?.INVOICE_NO);
                                                                    if (url !== false) {
                                                                        window.open(url, '_blank');
                                                                    }
                                                                }}
                                                                className="w-full pb-5 px-1 mt-2"
                                                            >
                                                                <p className="font-semibold text-[#090406] text-sm14 text-left"><u>View and Download Invoice</u></p>
                                                            </button>
                                                        )}
                                                    </div>
                                                    {invoice?.PAYMENT_STATUS?.includes('RETURN') && (
                                                        <div className="lg:w-[33%] w-[50%] pb-5 px-1 relative">
                                                            <p className="pt-2 pb-3 text-[#808285] font-semibold text-base cursor-pointer hover:text-[#555259]" onClick={() => { setreturnPopup(returnPopup === idx ? '' : idx); }}>View Return Request Comments</p>
                                                            {returnPopup === idx && (
                                                                <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more px-2.5 sm:py-4 py-3 shadow-s7 w-[250px] z-10 adderess-show2">
                                                                    <div className="flex items-center justify-between">
                                                                        <p className="sm:pt-2 pt-1.5 text-sm49 font-semibold text-[#555259]">Distributor Comment</p>
                                                                    </div>
                                                                    <p className=" text-xs font-semibold text-[#808285]">
                                                                        {invoice?.return_request_note}
                                                                    </p>
                                                                    {invoice?.return_request_atachment && invoice?.return_request_atachment.length > 0 && invoice?.return_request_atachment.map((document) => (
                                                                        <button
                                                                            className="w-auto flex items-center h-5 bg-[#F5F5FA] rounded-lg po-documnent"
                                                                            onClick={() => {
                                                                                window.open(`${CDN}/${document}`, '_blank');
                                                                            }}
                                                                        >
                                                                            <img src="/images/download.svg" alt="icon/" />
                                                                            <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download Return Document</p>
                                                                        </button>
                                                                    ))}
                                                                    <div className="flex items-center justify-between">
                                                                        <p className="sm:pt-2 pt-1.5 text-sm49 font-semibold text-[#555259]">Admin Comment</p>
                                                                    </div>
                                                                    <p className="text-xs font-semibold text-[#808285]">
                                                                        {invoice?.return_request_admin_respons}
                                                                    </p>
                                                                </div>

                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="lg:w-[50%] w-full bg-[#F5F5FA] rounded-lg px-3 py-2 mb-5 h-auto">
                                                <div className="w-full flex sm:nowrap flex-wrap justify-start px-4 pt-2.5 pb-2 rounded-lg xl:mt-0 mt-3 relative bg-white shadow-s9">
                                                    <button onClick={() => { setbilladdresspop(!billaddresspop); setshipbilladdresspop(false); }} type="button" className="pr-2 border-r border-[#CECECE] flex justify-between items-center xl:auto sm:w-1/2 w-full text-left showAddress-full2">
                                                        <div className="w-[80%]">
                                                            <p className="text-xs font-semibold text-[#808285]">Billing address</p>
                                                            <p className="text-xs6 font-semibold text-[#555259] more-lines">{invoice?.details[0]?.BILLING_ADDRESS?.ADDRESS1}</p>
                                                        </div>
                                                        <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[20%]">View</p>
                                                    </button>
                                                    {billaddresspop
                                                        && (
                                                            <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-10 adderess-show2">
                                                                <div className="flex items-center justify-between">
                                                                    <p className="sm:text-xs6 text-sm font-semibold text-[#808285]">Billing address</p>
                                                                </div>
                                                                <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                                                                    {invoice?.details[0]?.BILLING_ADDRESS?.ADDRESS1}
                                                                    {' '}
                                                                    {invoice?.details[0]?.BILLING_ADDRESS?.ADDRESS2}
                                                                    {' '}
                                                                    {invoice?.details[0]?.BILLING_ADDRESS?.ADDRESS3}
                                                                    {' '}
                                                                    {invoice?.details[0]?.BILLING_ADDRESS?.ADDRESS4}
                                                                    {' - '}
                                                                    {invoice?.details[0]?.BILLING_ADDRESS?.POSTAL_CODE}
                                                                    ,
                                                                    Location-
                                                                    {(invoice?.details[0]?.BILLING_ADDRESS?.LOCATION)}
                                                                    ,
                                                                    GSTIN-
                                                                    {(invoice?.details[0]?.BILLING_ADDRESS?.ATTRIBUTE2)}

                                                                </p>
                                                            </div>
                                                        )}
                                                    <div className="sm:px-2 px-0 xl:auto sm:w-1/2 w-full flex justify-between items-center sm:mt-0 mt-2">
                                                        <button onClick={() => { setshipbilladdresspop(!shipaddresspop); setbilladdresspop(false); }} type="button" className="pr-2 flex justify-between items-center xl:auto w-full text-left showAddress-full2">
                                                            <div className="w-[80%]">
                                                                <p className="text-xs font-semibold text-[#808285]">Shipping address</p>
                                                                <p className="text-xs6 font-semibold text-[#555259] more-lines">{invoice?.details[0]?.SHIPPING_ADDRESS?.ADDRESS1}</p>
                                                            </div>
                                                            <p className="font-semibold text-xs12 text-[#808285] cursor-pointer w-[20%]">View</p>
                                                        </button>
                                                    </div>
                                                    {shipaddresspop
                                                        && (
                                                            <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-10 adderess-show2 ml-[120px] ">
                                                                <div className="flex items-center justify-between">
                                                                    <p className="sm:text-xs6 text-sm font-semibold text-[#808285]">Shipping address</p>
                                                                </div>
                                                                <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                                                                    {invoice?.details[0]?.SHIPPING_ADDRESS?.ADDRESS1}
                                                                    {' '}
                                                                    {invoice?.details[0]?.SHIPPING_ADDRESS?.ADDRESS2}
                                                                    {' '}
                                                                    {invoice?.details[0]?.SHIPPING_ADDRESS?.ADDRESS3}
                                                                    {' '}
                                                                    {invoice?.details[0]?.SHIPPING_ADDRESS?.ADDRESS4}
                                                                    {' - '}
                                                                    {invoice?.details[0]?.SHIPPING_ADDRESS?.POSTAL_CODE}
                                                                    ,
                                                                    Location-
                                                                    {(invoice?.details[0]?.SHIPPING_ADDRESS?.LOCATION)}
                                                                    ,
                                                                    GSTIN-
                                                                    {(invoice?.details[0]?.SHIPPING_ADDRESS?.ATTRIBUTE2)}
                                                                </p>
                                                            </div>
                                                        )}
                                                </div>
                                                <div className="flex w-full">
                                                    <div className="mt-3 w-1/2">
                                                        <p className="text-xs font-semibold text-[#777777]">Transporter Name</p>
                                                        {invoice?.TRANSPORTER_NAME === null
                                                            ? <p className="text-sm font-normal text-[#090406] mt-[2px]">-</p>
                                                            : <p className="text-sm font-normal text-[#090406] mt-[2px]">{invoice?.TRANSPORTER_NAME}</p>}
                                                    </div>
                                                    <div className="mt-3 w-1/2">
                                                        <p className="text-xs font-semibold text-[#777777]">Shipped From</p>
                                                        <p className="text-sm font-normal text-[#090406] mt-[2px]">{invoice?.SHIP_FROM}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="border-t border-[#CBCBCB]">
                                        <p className="pt-2 pb-3 text-[#090406] font-semibold text-base">Related Documents</p>
                                        <div className="flex flex-wrap items-start">
                                            {(invoice?.e_way_bill === null || invoice?.e_way_bill === '') ? null
                                                : (
                                                    <button
                                                        className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg E-way-bill mb-3"
                                                        onClick={() => {
                                                            window.open(`${CDN}/${invoice?.e_way_bill}`, '_blank');
                                                        }}
                                                    >
                                                        <img src="/images/download.svg" alt="icon" />
                                                        <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download E-way Bill</p>
                                                    </button>
                                                )}

                                            {(invoice?.lr_copy === null || invoice?.lr_copy === '') ? null
                                                : (
                                                    <button
                                                        className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg mx-3 LR-Copy mb-3"
                                                        onClick={() => {
                                                            window.open(`${CDN}/${invoice?.lr_copy}`, '_blank');
                                                        }}
                                                    >
                                                        <img src="/images/download.svg" alt="icon" />
                                                        <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download LR Copy</p>
                                                    </button>
                                                )}

                                            {(invoice?.invoice === null || invoice?.invoice === '') ? null : (
                                                <button
                                                    onClick={() => {
                                                        window.open(`${CDN}/${invoice.invoice}`, '_blank');
                                                    }}
                                                    className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg Invoice mb-3"
                                                >
                                                    <img src="/images/download.svg" alt="icon" />
                                                    <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download Invoice</p>
                                                </button>
                                            )}
                                            {OrderDetails?.po_document?.length > 0 && OrderDetails?.po_document.map((item) => (
                                                (
                                                    <button
                                                        className="w-auto flex items-center h-9 px-3 bg-[#F5F5FA] rounded-lg md:ml-3 ml-0 mb-3 po-documnent"
                                                        onClick={() => {
                                                            window.open(`${CDN}/${item}`, '_blank');
                                                        }}
                                                    >
                                                        <img src="/images/download.svg" alt="icon" />
                                                        <p className="font-semibold text-[#5B5B5B] text-xs3 ml-1">Download PO Document</p>
                                                    </button>
                                                )
                                            ))}
                                        </div>
                                        <div className="overflow-auto Menu-list h-[350px]">
                                            {invoice?.details.length > 0 && invoice?.details.map((item, index) => (
                                                <div className="mt-3 mb-5" key={index}>
                                                    <div className="border border-[#D9D9D9] rounded-lg p-2.5">
                                                        <div className="flex justify-between w-full items-start md:flex-row flex-col">
                                                            <div className="mb-3 md:w-[75%] w-full">
                                                                <div className="flex">
                                                                    <img src={handleImage(item?.IMAGE_NAME)} alt="image" className="mr-4 h-[50px] w-[50px]" style={{ objectFit: 'cover' }} />
                                                                    <div className="">
                                                                        <p className="text-xs6 font-normal text-[#090406] pr-3 break-words">{item?.MODEL_DESCRIPTION}</p>
                                                                        <p className="sm:text-xs3 font-normal text-[#808285] mt-1">
                                                                            <span>
                                                                                Product Code:
                                                                                {' '}
                                                                                {`${item.CONCATENATED_SEGMENTS}`}
                                                                            </span>
                                                                            <span className="sm:px-4 px-2">|</span>
                                                                            <span>
                                                                                AWS Classification:
                                                                                {' '}
                                                                                {item?.AWS_CLASSIFICATION}
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <p className="font-normal text-xs3 text-[#808285] pt-2.5">{item?.DESCRIPTION}</p>
                                                            </div>
                                                            <div className="md:w-[25%] w-full mb-3">
                                                                {Object.values(item?.test_certificates).includes(null)
                                                                    ? (
                                                                        <div>
                                                                            <p className="font-semibold text-[#5B5B5B] text-xs3">Machine Serial Number</p>
                                                                            {item?.test_certificates && Object.entries(item?.test_certificates).map((test, idx2) => (
                                                                                <p className="font-normal text-[#303030] text-xs3 mt-1.5" key={idx2}>
                                                                                    {test[0]}
                                                                                    ,
                                                                                    {' '}
                                                                                </p>
                                                                            ))}
                                                                        </div>
                                                                    )
                                                                    : (
                                                                        <div>
                                                                            <p className="font-semibold text-[#5B5B5B] text-xs3">View and Download Test Certificate(s)</p>
                                                                            {item?.test_certificates && Object.entries(item?.test_certificates).map((test, idx1) => (
                                                                                <a target="_blank" rel="noreferrer" className="font-normal underline text-[#303030] text-xs3 mt-1.5 cursor-pointer" href={test[1]} key={idx1}>
                                                                                    {test[0]}
                                                                                    ,
                                                                                    {' '}
                                                                                </a>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                {/* {item?.test_certificates.length > 0 && Object.entries(item?.test_certificates).map((certificate, i) => (
                                                                    <a target="_blank" className="font-normal text-[#303030] text-xs3 mt-1.5 cursor-pointer" href={certificate[1]} key={i} rel="noreferrer">{certificate[0]}</a>
                                                                ))} */}
                                                            </div>
                                                        </div>
                                                        <div className="w-[95%]">
                                                            <div className="w-full flex">
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(item?.LIST_PRICE)}</p>
                                                                </div>
                                                                <div className="ml-2.5 pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Quantity</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">
                                                                        {item?.INVOICED_QUANTITY}
                                                                        {' '}
                                                                        {item?.PRIMARY_UOM_CODE || 'Kg'}
                                                                    </p>
                                                                </div>
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">Basic Value</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler((item?.LIST_PRICE * item?.INVOICED_QUANTITY))}</p>
                                                                </div>
                                                                <div className="w-1/5">
                                                                    <p className="font-semibold text-[#808285] text-xs3">Discount </p>
                                                                    <p className="font-semibold text-[#15090E] text-xs9">{PriceHandler(Number(item?.TD_VALUE) + Number(item?.AD_VALUE))}</p>
                                                                </div>
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">DAP</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(item?.DAP_VALUE)}</p>
                                                                </div>
                                                            </div>
                                                            <div className="w-full flex">
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">Net Amount</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(Number(item?.NET_VALUE) + Number(item?.CD_VALUE))}</p>
                                                                </div>
                                                                <div className="ml-2.5 pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Ador Cash</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{item?.CD_VALUE === null ? PriceHandler(0) : PriceHandler(item?.CD_VALUE)}</p>
                                                                </div>
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">Net Value</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(item?.NET_VALUE)}</p>
                                                                </div>
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">GST</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(item?.GST_TAXES)}</p>
                                                                </div>
                                                                <div className="pb-5 w-1/5">
                                                                    <p className="text-xs3 font-semibold text-[#808285]">Gross Amount</p>
                                                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(item?.LINE_TOTAL_AMOUNT)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
